import { render, staticRenderFns } from "./MyBookkeeping.vue?vue&type=template&id=34856db3&"
import script from "./MyBookkeeping.vue?vue&type=script&lang=js&"
export * from "./MyBookkeeping.vue?vue&type=script&lang=js&"
import style0 from "./MyBookkeeping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports